import { useEffect, memo } from 'react';
import { useAppSelector } from '../../store/store';
import { IPerson, selectPersonLoggedIn } from '../../store/slices/auth';

import { useLocation, useNavigate } from 'react-router-dom';
// import { setSDPOffer } from '../../store/slices/chat';
// import { useDispatch } from 'react-redux';
import WithLoader from '../../components/WithLoader/WithLoader';
import ReadFile from './ReadFile';
import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import profileIcon from '../../assets/profiles/profile1.svg';
import moment from 'moment';
import styles from './Chat.module.scss';
import { useTranslation } from '../../hooks/useTranslations';

interface Props {
  chatHistory: any;
  isLoading: boolean;
  conversationParticipants: any;
  style?: any;
  bodyStyle?: React.CSSProperties;
}

const ChatBody = memo(({ chatHistory, isLoading, conversationParticipants, style }: Props) => {
  const { translations } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const personLoggedIn = useAppSelector<IPerson>(selectPersonLoggedIn);
  const { currentConversation } = useAppSelector((state) => state.chat);

  useEffect(() => {
    const element: any = document.getElementById('chat-wrapper');
    element.scrollTop = element.scrollHeight;
  }, [chatHistory]);

  const imageFileTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];

  const handleJoinVideoCall = (el: any) => {
    // dispatch(setSDPOffer(el.message_offer_payload));
    navigate(`/web/video-call?id=${currentConversation.conversation_id}&action=initiate-answer`, {
      state: el.message_offer_payload,
    });
  };

  return (
    <div
      id="chat-wrapper"
      className={
        currentConversation
          ? currentConversation?.conversation_status === 'C'
            ? `${styles.chatPanel} ${styles.closedConversaitons}`
            : `${styles.chatPanel}`
          : `${styles.chatPanel} ${styles.rmBorder}`
      }
      style={style || null}
    >
      <div className={styles.chatBody}>
        <WithLoader isLoading={isLoading}>
          {chatHistory.map((el: any, idx: number, array: any) => {
            let status = el?.message_status?.find((e: any) =>
              ['R', 'R '].includes(e.current_status)
            );
            let sender = conversationParticipants?.find(
              (item: any) => item.personId === el.person_id
            );
            let prevDate = moment(array[idx - 1]?.created_at).format('DD.MM.YYYY ');
            let currentDate = moment(el?.created_at).format('DD.MM.YYYY');

            if (el.type === 'F') {
              let isImage = imageFileTypes.includes(el.mimeType);
              const blob = new Blob([el.payload], { type: el.mimeType });
              // eslint-disable-next-line
              if (el.person_id == personLoggedIn.person_external_id) {
                return (
                  <div key={idx} className={`${styles.messageWrapper} ${styles.blue}`}>
                    <img src={profileIcon} alt="Avatar" className={styles.avatar} />
                    <div
                      className={
                        isImage
                          ? `${styles.message} ${styles.sentImage}`
                          : `${styles.message} ${styles.blue}`
                      }
                    >
                      <ReadFile fileName={el.fileName} blob={blob} mimeType={el.mimeType} />
                    </div>
                  </div>
                );
              }
              return (
                <div key={idx} className={`${styles.messageWrapper} ${styles.gray}`}>
                  <img src={profileIcon} alt="Avatar" className={styles.avatar} />
                  <div
                    key={idx}
                    className={
                      isImage
                        ? `${styles.message} ${styles.reciveImage}`
                        : `${styles.message}  ${styles.gray}`
                    }
                  >
                    <ReadFile fileName={el.fileName} blob={blob} mimeType={el.mimeType} />
                  </div>
                </div>
              );
            }
            if (el.type === 'A') {
              return (
                <div className={styles.assignToDoc} key={idx}>
                  <div className={styles.text}>
                    <div>
                      {' '}
                      {translations('assign.to')} <span>{el.payload}</span>
                    </div>
                    <p>{` ${moment(el?.created_at).format('DD.MM.YYYY HH:mm')}`}</p>
                  </div>
                </div>
              );
            }
            if (el.type === 'R') {
              return (
                <div className={styles.assignToDoc} key={idx}>
                  <div className={styles.text}>
                    <div>
                      {' '}
                      {translations('reassign.to')} <span>{el.payload}</span>
                    </div>
                    <p>{` ${moment(el?.created_at).format('DD.MM.YYYY HH:mm')}`}</p>
                  </div>
                </div>
              );
            }
            if (el.type === 'C') {
              return (
                <div className={styles.assignToDoc} key={idx}>
                  <div className={styles.text}>
                    <div>
                      {' '}
                      {translations('label.closed')} <span>{el.payload}</span>
                    </div>
                    <p>{` ${moment(el?.created_at).format('DD.MM.YYYY HH:mm')}`}</p>
                  </div>
                </div>
              );
            }
            if (el.type === 'S') {
              if (el.person_id == personLoggedIn.person_external_id) {
                return (
                  <div className={styles.assignToDoc} key={idx}>
                    <div className={styles.text} style={{ bottom: '-33px' }}>
                      <div>
                        <span>{translations('video.call')}</span>
                      </div>
                      <p>{` ${moment(el?.created_at).format('DD.MM.YYYY HH:mm')}`}</p>
                    </div>
                  </div>
                );
              }
              return (
                <div className={styles.assignToDoc} key={idx} style={{ margin: '40px 10px' }}>
                  <div className={styles.text} style={{ bottom: '-48px' }}>
                    <div>
                      <PrimaryButtonV2
                        text={
                          el.message_offer_payload === null ? 'Video call ended' : 'Join Video Call'
                        }
                        buttonStyle={{ fontSize: '14px', height: '45px' }}
                        onClick={() => handleJoinVideoCall(el)}
                        disabled={
                          el.message_offer_payload === null ||
                          location.pathname.includes('/web/video-call')
                        }
                      />
                    </div>
                    <p>{` ${moment(el?.created_at).format('DD.MM.YYYY HH:mm')}`}</p>
                  </div>
                </div>
              );
            }
            if (el.type === 'E') {
              return (
                <div className={styles.assignToDoc} key={idx}>
                  <div className={styles.text} style={{ bottom: '-33px' }}>
                    <div>
                      <span>{translations('video.call.finished')}</span>
                    </div>
                    <p>{` ${moment(el?.created_at).format(' DD.MM.YYYY HH:mm')}`}</p>
                  </div>
                </div>
              );
            }
            // eslint-disable-next-line
            if (el.person_id == personLoggedIn.person_external_id) {
              return (
                <div className={styles.chat} key={idx}>
                  <ShowDate prevDate={prevDate} currentDate={currentDate} />
                  <div className={styles.sent}>
                    <div className={`${styles.messageWrapper}`}>
                      {/* <img src={profileIcon} alt="Avatar" className={styles.avatar} /> */}
                      <div className={`${styles.message} ${styles.blue}`}>
                        <p>{el.payload}</p>
                        <div className={styles.wrapInfo}>
                          <span>{moment(el.created_at).format('HH:mm')}</span>
                          {status ? <i className={styles.whiteDoubleTickIcon}></i> : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            return (
              <div className={styles.chat} key={idx}>
                <ShowDate prevDate={prevDate} currentDate={currentDate} />
                <div className={styles.recive}>
                  <p className={styles.senderName}>
                    {sender ? `${sender?.personName} ${sender?.personLastname}` : ''}
                  </p>
                  <div className={`${styles.messageWrapper}`}>
                    {/* <img src={profileIcon} alt="Avatar" className={styles.avatar} /> */}
                    <div className={`${styles.message}  ${styles.gray}`}>
                      <p>{el.payload}</p>
                      <div className={styles.wrapInfo}>
                        <span>{moment(el.created_at).format('HH:mm')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </WithLoader>
      </div>
    </div>
  );
});

const ShowDate = ({ prevDate, currentDate }: any) => {
  if (prevDate < currentDate) {
    return (
      <div className={`${styles.assignToDoc}`}>
        <div style={{ bottom: '-15px' }} className={`${styles.text}`}>
          <p className={styles.date}>{`${currentDate}`}</p>
        </div>
      </div>
    );
  }
  return null;
};

export default ChatBody;
